import { orderTermIsNet60 } from "../../utils/orderTermIsNet60";
import { orderTermIsPaymentOnShipment } from "../../utils/orderTermIsPaymentOnShipment";
import { orderWasAlreadyCharged } from "../../utils/orderWasAlreadyCharged";
export var RefundsIA = function RefundsIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return REFUNDS(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getDescription(context, strictLocalize);
    }
  };
};
var getDescription = function getDescription(context, strictLocalize) {
  var withSharedParagraphs = function withSharedParagraphs(intro) {
    return [intro(strictLocalize), PLEASE_NOTE(strictLocalize), FREE_RETURNS_ELIGIBLE_FOR_FIRST_BRAND_ORDER(strictLocalize)];
  };
  var brandOrder = context.brandOrder;
  if (!brandOrder) {
    return withSharedParagraphs(REFUNDS_EXPLANATION);
  }
  if (orderTermIsNet60(brandOrder) && !orderWasAlreadyCharged(brandOrder)) {
    return withSharedParagraphs(WE_WILL_NOT_CHARGE_YOU);
  }
  if (orderTermIsPaymentOnShipment(brandOrder)) {
    return withSharedParagraphs(YOU_WILL_GET_A_REFUND);
  }
  return withSharedParagraphs(REFUNDS_EXPLANATION);
};
var REFUNDS = function REFUNDS(strictLocalize) {
  return strictLocalize({
    id: "j0Zb++",
    defaultMessage: "How refunds work"
  });
};
var WE_WILL_NOT_CHARGE_YOU = function WE_WILL_NOT_CHARGE_YOU(strictLocalize) {
  return strictLocalize({
    id: "nlChIa",
    defaultMessage: "Since order was placed using net60 payment terms and the invoice is not paid, we won’t charge you for the items you’re returning."
  });
};
var FREE_RETURNS_ELIGIBLE_FOR_FIRST_BRAND_ORDER = function FREE_RETURNS_ELIGIBLE_FOR_FIRST_BRAND_ORDER(strictLocalize) {
  return strictLocalize({
    id: "8EzeWX",
    defaultMessage: "Free returns are only eligible on your first order with a brand. Return shipping costs are covered by Faire, but the original shipping costs and import fees are non-refundable. If an invoice has been paid with Faire credit and a payment card, the credit will be returned first. If Faire Direct credit was originally used to pay for an order that was returned, it will not be restored automatically to your Faire account as credit."
  });
};
var YOU_WILL_GET_A_REFUND = function YOU_WILL_GET_A_REFUND(strictLocalize) {
  return strictLocalize({
    id: "HOxj0J",
    defaultMessage: "Since the order was placed using payment on shipment, the cost of items you’re returning will be refunded directly to your original payment method at the time the return is scanned into transit by the carrier. Please allow 5–10 business days for the refund to show up on your payment method."
  });
};
var REFUNDS_EXPLANATION = function REFUNDS_EXPLANATION(strictLocalize) {
  return strictLocalize({
    id: "DB4OtG",
    defaultMessage: "If the order was placed using net 60 payment terms and the invoice isn’t paid, we won’t charge you for the items you’re returning. If the order was placed using payment on shipment, the cost of items you’re returning will be refunded directly to your original payment method at the time the return is scanned into transit by the carrier. Please allow 5–10 business days for the refund to show up on your payment method."
  });
};
var PLEASE_NOTE = function PLEASE_NOTE(strictLocalize) {
  return strictLocalize({
    id: "Vr8ECj",
    defaultMessage: "Please note:"
  });
};